(function () {
  function initExpandableDescription(root) {
    if (!root || root.dataset.vrvDescReady === '1') return;

    const body = root.querySelector('[data-vrv-desc-body]');
    const toggle = root.querySelector('[data-vrv-desc-toggle]');
    if (!body || !toggle) return;

    const lines = Math.max(2, parseInt(root.dataset.previewLines || '4', 10) || 4);

    const measure = () => {
      body.classList.remove('is-collapsed', 'is-expanded');
      body.style.maxHeight = 'none';

      const lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 26;
      const maxCollapsed = Math.round(lineHeight * lines);
      const fullHeight = body.scrollHeight;

      if (fullHeight <= maxCollapsed + 6) {
        toggle.hidden = true;
        root.dataset.vrvDescReady = '1';
        return;
      }

      const expand = () => {
        body.classList.remove('is-collapsed');
        body.classList.add('is-expanded');
        body.style.maxHeight = fullHeight + 'px';
        toggle.textContent = 'Show Less';
        toggle.setAttribute('aria-expanded', 'true');
      };

      const collapse = (smooth) => {
        body.classList.add('is-collapsed');
        body.classList.remove('is-expanded');
        body.style.maxHeight = maxCollapsed + 'px';
        toggle.textContent = 'Show More';
        toggle.setAttribute('aria-expanded', 'false');
        if (smooth) {
          root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      };

      collapse(false);
      toggle.hidden = false;

      toggle.addEventListener('click', () => {
        if (body.classList.contains('is-collapsed')) {
          expand();
        } else {
          collapse(true);
        }
      });

      root.dataset.vrvDescReady = '1';
    };

    if (document.fonts && typeof document.fonts.ready === 'object') {
      document.fonts.ready.then(measure).catch(measure);
    } else {
      requestAnimationFrame(measure);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vrv-desc-expand]').forEach(initExpandableDescription);
  }

  window.vrvInitPdpDescriptions = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
})();
